import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './admin-cards.loaders';
import { converters } from './admin-cards.converters';
import { AdminCardsFilters } from './admin-cards.types';

export const adminBrandCardsKeys = queryKeyFactory('admin-cards');

export const useAdminCards = (filters: Partial<AdminCardsFilters> = {}) => {
  return useQuery({
    queryKey: adminBrandCardsKeys.list(filters),
    queryFn: () => loaders.getCards({ filters }),
    select: converters.getCards,
    keepPreviousData: true,
  });
};

export const useAdminCard = (cardId: string) => {
  return useQuery({
    queryKey: adminBrandCardsKeys.detail(cardId),
    queryFn: () => loaders.getCard({ cardId }),
    select: converters.getCard,
    enabled: !!cardId,
  });
};
